import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const verifySubdomainRoute = () => {
  let urlVerification = window.location.hostname.indexOf('.');
  if ( urlVerification === -1 ) return false;

  let url = window.location.hostname.split('.')[0];
  let regex = /[^a-zA-Z ]/g;
  let regexed = url.replace(regex);

  if ( !regexed || regexed === "" ) return false;
  return true;
}

export const SubdomainRoute = ({component: Component, ...rest}) => (
  <Route {...rest} render={props => (
    verifySubdomainRoute() === true
    ? <Component {...props} />
    : <Redirect to={{pathname: '/signup/company', state: {from: props.location}}} />
  )} />
)